module.exports = __webpack_public_path__ + "img/t.d6898a02.png";